module.exports = __webpack_public_path__ + "img/logo-jsmssmg.84702086.png";